import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-action-time-jump-large.tsx
/**
* icon.24.action.time.jump.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyLjUgNEExLjUgMS41IDAgMCAxIDE0IDUuNXYxM2ExLjUgMS41IDAgMCAxLTEuNSAxLjVoLTFhMS41IDEuNSAwIDAgMS0xLjUtMS41di0xM0ExLjUgMS41IDAgMCAxIDExLjUgNHptLTEgMWEuNS41IDAgMCAwLS41LjV2MTNhLjUuNSAwIDAgMCAuNS41aDFhLjUuNSAwIDAgMCAuNS0uNXYtMTNhLjUuNSAwIDAgMC0uNS0uNXpNNi4zNiA4LjczMUExIDEgMCAwIDEgOCA5LjV2NWExIDEgMCAwIDEtMS42NC43NjlsLTMtMi41YTEgMSAwIDAgMSAwLTEuNTM4em0xMC4yMTYtLjEzNmExIDEgMCAwIDEgMS4wNjUuMTM2bDMgMi41YTEgMSAwIDAgMSAwIDEuNTM4bC0zIDIuNUExIDEgMCAwIDEgMTYgMTQuNXYtNWExIDEgMCAwIDEgLjU3Ni0uOTA1TTQgMTJsMyAyLjV2LTV6bTEzIDIuNSAzLTIuNS0zLTIuNXoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26677-58651
*/
const Icon24ActionTimeJumpLarge = memo(function Icon24ActionTimeJumpLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12.5 4A1.5 1.5 0 0 1 14 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 11.5 4zm-1 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5zM6.36 8.731A1 1 0 0 1 8 9.5v5a1 1 0 0 1-1.64.769l-3-2.5a1 1 0 0 1 0-1.538zm10.216-.136a1 1 0 0 1 1.065.136l3 2.5a1 1 0 0 1 0 1.538l-3 2.5A1 1 0 0 1 16 14.5v-5a1 1 0 0 1 .576-.905M4 12l3 2.5v-5zm13 2.5 3-2.5-3-2.5z"
		})
	});
});
//#endregion
export { Icon24ActionTimeJumpLarge };

//# sourceMappingURL=icon-24-action-time-jump-large.js.map